import React from 'react';
import { CheckCircleIcon, XCircleIcon, ClockIcon } from '@heroicons/react/24/solid';
import './RecruitmentStatus.css';

const STATUS_STEPS = [
  { id: 'applied', label: 'Applied' },
  { id: 'verification', label: 'Verification' },
  { id: 'interview', label: 'Interview' },
  { id: 'placed', label: 'Placement' }
];

const RecruitmentStatus = ({ status, registration }) => {
  // Helper to determine step state: 'current', 'completed', 'pending', 'rejected'
  const getStepState = (stepId) => {
    // Define status mapping to steps
    const statusMap = {
        'applied': 0,
        'verification_pending': 1,
        'verified': 1,
        'verification_failed': 1,
        'interview_scheduled': 2,
        'interview_completed': 2,
        'interview_failed': 2,
        'placed': 3,
        'placement_active': 3,
        'placement_completed': 3,
        'placement_terminated': 3
    };

    const currentStepIndex = statusMap[status] !== undefined ? statusMap[status] : 0;
    const stepIndex = STATUS_STEPS.findIndex(s => s.id === stepId);

    if (stepIndex < currentStepIndex) return 'completed';
    if (stepIndex === currentStepIndex) {
        if (status.includes('failed') || status.includes('rejected')) return 'rejected';
        // If verified, we are technically done with verification, but until we move to interview, we are "at" verification stage or waiting.
        // Let's say if verified, verification is green.
        if (status === 'verified') return 'completed'; 
        if (status === 'interview_completed') return 'completed';
        if (status === 'placement_completed') return 'completed';
        return 'current';
    }
    return 'pending';
  };

  return (
    <div className="recruitment-status">
      <div className="recruitment-status-steps">
        <div className="recruitment-status-track" aria-hidden="true"></div>
        {STATUS_STEPS.map((step, index) => {
          const state = getStepState(step.id);
          let icon = <span className="recruitment-status-dot" aria-hidden="true" />;

          if (state === 'completed') {
            icon = <CheckCircleIcon className="recruitment-status-icon recruitment-status-icon--completed" aria-hidden="true" />;
          } else if (state === 'current') {
            icon = <ClockIcon className="recruitment-status-icon recruitment-status-icon--current" aria-hidden="true" />;
          } else if (state === 'rejected') {
            icon = <XCircleIcon className="recruitment-status-icon recruitment-status-icon--rejected" aria-hidden="true" />;
          }

          return (
            <div key={step.id} className={`recruitment-status-step recruitment-status-step--${state}`}>
               {icon}
               <span className="recruitment-status-label">
                 {step.label}
               </span>
            </div>
          );
        })}
      </div>
      
      {/* Detailed Status Message */}
      <div className="recruitment-status-message">
        <p>
          <strong>Current Status:</strong> {registration.status_display}
        </p>
        {status === 'verification_failed' && (
            <p className="recruitment-status-error">
                Please check your documents. Some were rejected.
            </p>
        )}
      </div>
    </div>
  );
};

export default RecruitmentStatus;
